var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('div',{staticClass:"amex-geo-banner"},[_c('div',{staticClass:"amex-geo-banner__background"}),_c('button',{staticClass:"amex-geo-banner__submit",on:{"click":function($event){return _vm.close()}}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }